import Http from '../../../http';
import {
  CREATE_WAITING_LIST,
  FETCH_WAITING_LIST,
  UPDATE_WAITING_LIST,
} from './constants';

const createAction = data => ({
  type: CREATE_WAITING_LIST,
  payload: data,
});

export const shopCreate = (shopId, data) => dispatch =>
  Http
    .post(`/shop/${shopId}/waiting-list`, data)
    .then(response => dispatch(createAction(response)));

export const barberCreate = (barberId, data) => dispatch =>
  Http
    .post(`/barber/${barberId}/waiting-list`, data)
    .then(response => dispatch(createAction(response)));

const updateAction = data => ({
  type: UPDATE_WAITING_LIST,
  payload: data,
});

export const shopUpdate = (shopId, data) => dispatch =>
  Http
    .put(`/shop/${shopId}/waiting-list`, data)
    .then(response => dispatch(updateAction(response)));

export const barberUpdate = (barberId, data) => dispatch =>
  Http
    .put(`/barber/${barberId}/waiting-list`, data)
    .then(response => dispatch(updateAction(response)));

const fetchAction = data => ({
  type: FETCH_WAITING_LIST,
  payload: data,
});

export const shopFetch = shopId => dispatch =>
  Http.get(`/shop/${shopId}/waiting-list`).then(data => dispatch(fetchAction(data)));

export const barberFetch = barberId => dispatch =>
  Http.get(`/barber/${barberId}/waiting-list`).then(data => dispatch(fetchAction(data)));
